/*
 * bleach
 * a minimal html sanitizer
 * cam@onswipe.com
 */

module.exports = require('./lib/bleach.js');
